document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('#second-choice-container');
  if (!container) return;

  const updateSecondChoiceDescription = (variantId) => {
    if (!variantId) return;
    const boxes = container.querySelectorAll('.second-choice-description');
    boxes.forEach((box) => {
      const belongsToVariant = String(box.dataset.variantId) === String(variantId);
      box.hidden = !belongsToVariant;
    });
  };

  // Produktformular finden (Dawn main product form)
  const productForm = document.querySelector('product-form form[action*="/cart/add"]')
    || document.querySelector('form[action*="/cart/add"]');

  if (!productForm) return;

  const variantIdInput = productForm.querySelector('input[name="id"]');
  if (!variantIdInput) return;

  // 1) Beim Laden direkt mit aktueller Variante initialisieren
  updateSecondChoiceDescription(variantIdInput.value);

  // 2) Auf jede Änderung des versteckten Variant-ID-Inputs reagieren
  const observer = new MutationObserver(() => {
    updateSecondChoiceDescription(variantIdInput.value);
  });

  observer.observe(variantIdInput, { attributes: true, attributeFilter: ['value'] });

  // 3) Fallback: wenn Theme Variante per Change-Event ändert
  productForm.addEventListener('change', () => {
    updateSecondChoiceDescription(variantIdInput.value);
  });
});
